/**
 * Forbidden Page — 403
 * Shown when the session is valid but the user is not a Dev Admin.
 *
 * AXF-1013: the action used to be *Sign out*, which for a legitimate customer user who merely
 * opened the wrong URL would have ended their AX WorkFlow session as well — hostile, and worse
 * once the portal has no sign-in to return through. It offers a way back instead, and calls
 * nothing: no endpoint, no session change.
 *
 * `ENV.APP_URL` empty renders the text without the button rather than a dead one (spec R12).
 */
import { Button, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { ENV } from '@shared/config/env'

export function ForbiddenPage() {
  const { t } = useTranslation()

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f5f5f5',
      }}
    >
      <Result
        status="403"
        title={t('errors.forbidden.title')}
        subTitle={t('errors.forbidden.subtitle')}
        extra={
          ENV.APP_URL ? (
            <Button type="primary" href={ENV.APP_URL}>
              {t('errors.forbidden.backToAxWorkFlow')}
            </Button>
          ) : null
        }
      />
    </div>
  )
}

export default ForbiddenPage
